import { Box } from '@mui/material';
import { fmtHours } from '../utils/hours';
import StatCard from './StatCard';

/** The List view's headline row: team utilisation, then how many people are at each load level. */
export default function ListStats({ summary }) {
  const { totals, levels } = summary;

  return (
    <Box display="grid" gridTemplateColumns={{ xs: 'repeat(2, minmax(0, 1fr))', lg: 'repeat(5, minmax(0, 1fr))' }} gap={2} sx={{ mt: 3 }}>
      <StatCard
        label="Team utilisation"
        value={totals.capacity ? `${Math.round(totals.utilisation)}%` : '-'}
        note={`${fmtHours(totals.allocated)} allocated of ${fmtHours(totals.capacity)}`}
      />
      <StatCard label="Overloaded" value={levels.overloaded} note={`${fmtHours(totals.over)} over capacity`} level="overloaded" />
      <StatCard label="At capacity" value={levels.atCapacity} note={`${fmtHours(totals.headroomAtCapacity)} headroom`} level="atCapacity" />
      <StatCard label="Balanced" value={levels.balanced} note={`${fmtHours(totals.headroomBalanced)} headroom`} level="balanced" />
      <StatCard label="Available" value={levels.available} note={`${fmtHours(totals.freeAvailable)} free to assign`} level="available" />
    </Box>
  );
}
